var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99994 7.99931C6.86833 8.00007 6.73787 7.97484 6.61603 7.92508C6.4942 7.87532 6.38338 7.802 6.28994 7.70932L0.289941 1.70961C0.101638 1.52132 -0.00415039 1.26594 -0.00415039 0.999648C-0.00415039 0.73336 0.101638 0.477977 0.289941 0.289683C0.478245 0.101388 0.73364 -0.00439453 0.999941 -0.00439453C1.26624 -0.00439453 1.52164 0.101388 1.70994 0.289683L6.99994 5.58942L12.2899 0.299683C12.4812 0.135864 12.7273 0.0502618 12.979 0.0599825C13.2307 0.0697032 13.4694 0.174031 13.6475 0.352117C13.8256 0.530203 13.9299 0.76893 13.9397 1.02059C13.9494 1.27226 13.8638 1.51832 13.6999 1.70961L7.69994 7.70932C7.51368 7.89406 7.26228 7.9982 6.99994 7.99931Z",
    fill: "#D6D6D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectRightIcon);
export default __webpack_public_path__ + "static/media/select-right-icon.ca88cbfccda1ff61362d9d4ba4b34a1d.svg";
export { ForwardRef as ReactComponent };